<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

defineProps<{
  modelValue: string | null;
}>();

const emit = defineEmits<{
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}>();
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-all duration-200 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-all duration-150 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="modelValue"
        class="fixed inset-0 z-[9999] flex items-center justify-center"
        @click.self="emit('cancel')"
      >
        <!-- Overlay -->
        <div class="absolute inset-0 bg-black/30 backdrop-blur-[2px]" />

        <!-- Modal -->
        <div
          class="relative z-10 mx-4 w-full max-w-sm overflow-hidden rounded-2xl bg-white shadow-2xl"
          @click.stop
        >
          <!-- Header -->
          <div class="px-6 pt-6 pb-4">
            <p class="text-16px font-tt-semiBold-Normal text-grand-text">
              Supprimer la collection
            </p>
            <p class="text-14px text-secondary-text mt-2 leading-relaxed">
              Voulez-vous vraiment supprimer la collection
              <span class="font-tt-medium-Normal text-grand-text">
                "{{ modelValue }}"
              </span>
              ? Cette action est irréversible.
            </p>
          </div>

          <!-- Actions -->
          <div class="flex items-center gap-3 px-6 pt-2 pb-6">
            <button
              @click="emit('cancel')"
              class="text-14px font-tt-medium-Normal text-secondary-text flex-1 rounded-xl border border-gray-200 py-2.5 transition-colors hover:bg-gray-50"
            >
              {{ t('catalogue.collections.cancel') }}
            </button>
            <button
              @click="emit('confirm')"
              class="text-14px font-tt-medium-Normal flex-1 rounded-xl bg-[#E63D4B] py-2.5 text-white transition-colors hover:bg-[#c93040]"
            >
              Supprimer
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
